import { Component, OnInit, Input, Output, EventEmitter, ViewChild, ElementRef } from '@angular/core';

@Component({
  selector: 'apc-create-element-buttons',
  templateUrl: './create-element-buttons.component.html',
  styleUrls: ['./create-element-buttons.component.scss'],
})
export class CreateElementButtonsComponent implements OnInit {
  public iconsExpanded = false;
  @Input() public buttons: any[];
  @Input() public permission: string;
  @Output() createEvent = new EventEmitter<string>();
  @ViewChild('input') input: ElementRef;
  public showButton: boolean = false;

  constructor() {}

  ngOnInit(): void {}

  expand() {
    var lists: any = document.getElementsByClassName('createElementsList');
    for (let i = 0; i < lists.length; i++) {
      lists[i].classList.add('ms-li' + Number(i + 1));
      if (i == 0) {
        lists[i].classList.add('ms-li-first');
      }
      if (i == lists.length - 1) {
        lists[i].classList.add('ms-li-last');
      }
    }
    this.iconsExpanded = !this.iconsExpanded;
  }

  createNew(key: string) {
    this.createEvent.emit(key);
    this.input.nativeElement.checked = false;
  }

  ngAfterViewInit() {
    var lists: any = document.getElementsByClassName('createElementsList');
    this.showButton = lists.length > 0;
  }


}
